import {Box, FormControl, Grid, TextField} from '@mui/material';
import {useEffect, useState} from 'react';
import OptionalServicesModal from '../../modal/OptionalServicesModal';
import {OptionalServices} from '../../../models/app';
import CloseIcon from '@mui/icons-material/Close';

const CartItem = ({updateCart, product, removeFromCart, calculateTotal, hasAdditionalTax, user}: any) => {

    const [qty, setQty] = useState(product?.quantity);
    useEffect(() => {
        setQty(product?.quantity);
    }, [product]);


    const [options, setOptions] = useState<OptionalServices[]>(product.services ?? []);
    const [open, setOpen] = useState(false);


    const handleChangeQty = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newQty = parseInt(event.target.value);
        if (!isNaN(newQty) && newQty > 0) {
            setQty(newQty);
            product.quantity = newQty;
            updateCart(product);
        }
    };


    const calculateServicesTotal = (services: OptionalServices[], quantity: number,price :number) => {
        return services.reduce((acc, curr) => {
            if (!curr.Selected) return acc; // Skip unselected services
            let total = 0;
            debugger;
            if (curr.CalcType === "Variable" ||curr.CalcType === "Percent") {
                total = quantity * curr.ServicePriceWithTax;
            } 
            return acc + total;
        }, 0);
    };
    

    const [showLabel] = useState(true);

    if (true) {
        return (
            <Grid
                container
                spacing={1}
                alignItems="center"
                style={{
                     paddingBottom: "15px",
                    backgroundColor:"white",
                    borderBottom:"10px solid lightgrey",
                    marginTop: 2,
                }}
            >
                {/* Product Image */}
                <Grid item xs={4} sm={3} style={{display: 'flex', alignItems: 'center'}}>
                    <Box
                        onClick={() => removeFromCart(product?.id)}
                        sx={{
                            marginLeft: {xs: '1px', sm: '30px'},
                            width: "35px",
                            height: "35px",
                            lineHeight: "35px",
                            fontSize: "14px",
                            color: "#141417",
                            fontWeight: "bold",
                            border: "1px solid #e5e5e5",
                            textAlign: "center",
                            borderRadius: "50%",
                            cursor: "pointer",
                            transition: "all 300ms ease",
                        }}
                    >
                        <CloseIcon style={{fontSize: "20px"}}/>
                    </Box>
                    <Box
                        sx={{
                            p: 1
                        }}
                    >
                        <img
                            src={
                                product?.image ??
                                require("../../../assets/images/Default-removebg-preview.png")
                            }
                            alt={product?.name}
                            style={{
                                width: "auto", height: "50px", cursor: "pointer"
                            }}
                        />
                    </Box>
                </Grid>
                {/* Product Name */}
                <Grid item xs={8} sm={3} mt={0} >
                    {showLabel && (
                        <div
                            style={{
                                fontSize: "12px",
                                marginBottom: "5px",
                                color: "#333",
                            }}
                        >
                                {product?.brand}
                        </div>
                    )}
                    <div
                        style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            marginBottom: "5px",
                            color: "#333",
                        }}
                    >
                        {product?.name}
                    </div>
                    <div
                        style={{
                            fontSize: "14px",
                            color: "#333",
                        }}
                    >
                        {product?.description}
                    </div>
                </Grid>

                {/* Additional Tax */}
                <Grid item xs={4} sm={1}  style={{ display : 'flex', flexDirection : 'row'}}>
                    {showLabel && product.additionalTax1 && hasAdditionalTax && (
                        <div
                            style={{
                                fontSize: "12px",
                                marginBottom: "5px",
                                color: "#333",
                                paddingLeft : '10px',
                                textAlign: "center", // Center text for mobile view
                            }}
                        >
                            FET :
                        </div>
                    )}
                    {product.additionalTax1 && hasAdditionalTax && (

                        <div
                            style={{
                                fontSize: "14px",
                                color: "#333",
                                paddingLeft : '2px',
                                textAlign: "center", // Center for mobile view
                            }}
                        >
                            {`$${parseFloat(product.additionalTax1).toFixed(2)}`}
                        </div>
                    )}
                </Grid>


                {/* Quantity */}
                <Grid item xs={4} sm={1} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <FormControl>
                        <TextField
                            id="quantity-select"
                            label="Qty"
                            type="number"
                            value={qty}
                            onChange={handleChangeQty}
                            InputProps={{
                                sx: {borderRadius: "5px", maxWidth: 80},
                            }}
                            InputLabelProps={{shrink: true}}
                            size="small"
                            style={{textAlign: "center"}} // Center for mobile view
                        />
                    </FormControl>
                </Grid>

                {/* Price */}
                {/* <Grid item xs={4} sm={2}   style={{ display : 'flex', flexDirection : 'row'}}>
                    {showLabel && (
                        <div
                            style={{
                                fontSize: "14px",
                                marginBottom: "5px",
                                color: "#333",
                                textAlign: "center", // Center text for mobile view
                            }}
                        >
                            Price :
                        </div>
                    )}
                    <div
                        style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            paddingLeft : '2px',
                            color: "#333",
                            textAlign: "center", // Center for mobile view
                        }}
                    >
                        {`$${(
                            (product?.price + (parseFloat(product.additionalTax1) ?? 0)) *
                            (qty || product?.quantity)
                        ).toFixed(2)}`}
                    </div>
                </Grid> */}
                <Grid item xs={4} sm={2} mt={0} >
                  
                    <div
                        style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            marginBottom: "5px",
                            color: "#333",
                        }}
                    >
                        {/* Price :{`$${(
                            (product?.price + (parseFloat(product.additionalTax1) ?? 0)) *
                            (qty || product?.quantity)
                        ).toFixed(2)}`} */}
                          Price :{`$${(
                            product?.price
                           
                        ).toFixed(2)}`}
                    </div>
                    <span
                        className = "blink"
                        style={{
                            color: "blue",
                            fontSize: "1rem",
                            animation: "blink 3s linear infinite", // CSS animation for blinking
                        }}
                        >
                      {product.showMessage ? 'Special Order 1-2 Business Days' : ''}
                    </span>
                </Grid>
                {/* Selected Services */}
                { <Grid item xs={12} sm={2} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    {((user !== "") &&
                      
                        <div
                            className="theme-btn theme-btn-eight"
                            style={{
                                fontSize: "14px",
                                cursor: "pointer",
                                borderRadius: "10px",
                                backgroundColor: "#d32f2f",
                                color: "#fff",
                                padding: "10px",
                                textAlign: "center",
                                margin: "auto", // Center for mobile view
                            }}
                            onClick={() => setOpen(!open)}
                        >
                            {`Selected Services: $${calculateServicesTotal(
                                product.services,
                                qty,product?.price
                            ).toFixed(2)}`}
                        </div>
                    )}
                </Grid>}

                {/* Optional Services Modal */}
                {options.length !== 0 && (
                    <OptionalServicesModal
                        product={product}
                        updateCart={updateCart}
                        calculateTotal={calculateTotal}
                        open={open}
                        setOpen={setOpen}
                        fields={options}
                        setOptions={setOptions}
                        isCart={true}
                    />
                )}
            </Grid>


        );
    }

}
export default CartItem;
